import { useState } from 'react';
import { Button } from '@/components/ui';
import { useVideoAction, videoApi } from '@/features/video-consults/api';
import type { StaffVideoSession } from '@/features/video-consults/types';
import { VideoError } from './VideoError';

/** RL-1002 "pay later": the patient may join before paying (fee due only). */
export function PayLaterButton({ s }: { s: StaffVideoSession }) {
  const a = useVideoAction(videoApi.payLater);
  const [error, setError] = useState<unknown>(null);
  return (
    <>
      <div>
        <Button
          size="sm"
          loading={a.isPending}
          onClick={() => {
            setError(null);
            a.mutateAsync({ id: s.id, version: s.version }).catch(
              (e: unknown) => setError(e),
            );
          }}
        >
          Let them pay after the call
        </Button>
      </div>
      {error !== null && <VideoError error={error} />}
    </>
  );
}
